<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="be-positive">
<h1>Be Positive</h1>
<p>It’s important to be positive</p>
<p>In the journey of life we have</p>
<p>There is so much to enjoy</p>
<p>Look around you and be glad</p><br/>
<p>In times of isolation</p>
<p>It’s important to make contact and talk</p>
<p>Do your best to make someone happy</p>
<p>Be active and take a walk</p><br/>
<p>Don’t just sit around feeling sorry</p>
<p>Or putting weight on around your tum</p>
<p>Stand up and be creative</p>
<p>Learn the lessons from your mum</p><br/>
<p>In a world that can be depressing</p>
<p>It’s important to stay on top</p>
<p>Please don’t be sad and lonely</p>
<p>But be active, and be nonstop</p><br/>
<p>Spend more time outdoors</p>
<p>Do something to activate your mind</p>
<p>Take in the fresh air</p>
<p>And of course be kind</p><br/>
<p>Yes life can be tough in all manner of ways</p>
<p>But it’s up to you to get your mindset right</p>
<p>Go to bed thinking positive things</p>
<p>Throw out the negatives and have a good night</p><br/>
<p>It’s easier said than done</p>
<p>I can hear you say</p>
<p>You are right, but remember</p>
<p>Eﬀort and hard work will pay</p><br/>
<p>Everyone has problems</p>
<p>I don’t care who you are</p>
<p>Stand up, stand proud, be happy</p>
<p>Fill up your positive jar</p><br/>
<p>You are a special being on Earth</p>
<p>No one is better than you</p>
<p>I wish you lots of happiness</p>
<p>I send all my love to you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?62f558be